import { ApiService } from '../../services/api_service';
import { IDs } from '../../helpers/IDs';
import { lazyInject } from '../../services/inversify';
import * as React from 'react';
import { WFormsTableWrapper } from '../../core/table/WFormsTableWrapper';
import { DataService } from '../../services/data_service';

export interface DatenmengeProps {
    data: any;
    galleryData: any;
    entities: Array<string>;
}

interface DatenmengeState {
    totalSize: number;
}

export class Datenmenge extends React.Component<DatenmengeProps, DatenmengeState> {

    constructor(props: any) {
        super(props);
        this.state = {
            totalSize: undefined
        };
        this.setDataForFiles = this.setDataForFiles.bind(this);
    }

    @lazyInject(ApiService) private apiService: ApiService;
    @lazyInject(DataService) private dataService: DataService;

    private dataForExport: any = {};
    private colsForExport: any = {};
    private buildHandle: number = undefined;

    render(): JSX.Element {
        if (this.state.totalSize || this.state.totalSize === 0) {
            return <div>Datenvolumen bisher hochgeladener Dateien: {(Math.round(this.state.totalSize / (1025 * 102.4)) / 10)} MB</div>;
        }
        return <div>
            <b>Datenmenge ermitteln ....</b>
            {this.renderExport()}
        </div>;
    }

    renderExport(): JSX.Element {
        return <div>
            {this.props.entities.map((ent: string) => this.renderExportEntity(ent))}
        </div>;
    }

    renderExportEntity(entity: string): JSX.Element {
        const data = this.props.data[entity] || [];
        if (data.length > 0) {
            return (
                <div style={{ display: 'none' }}>
                    <WFormsTableWrapper
                        entity={entity}
                        data={data}
                        module={IDs.MOD_ETOOL}
                        customClass={'Custom-ETA'}
                        passDataForExport={(data: Array<any>, cols: Array<any>) => this.setDataForFiles(entity, data, cols)}
                    />
                </div>
            );
        }
        return null;
    }

    setDataForFiles(entity: string, data: Array<any>, cols: Array<any>): void {
        if (!this.dataForExport[entity]) {
            this.dataForExport[entity] = data;
            this.colsForExport[entity] = cols;
        }
        const handle = window.setTimeout(() => {
            if (handle === this.buildHandle) {
                const files = this.prepareFiles();
                this.apiService.call(
                    'resolveSizes',
                    { files },
                    (data_res: string, suc: boolean) => {
                        const data_sizes = JSON.parse(data_res);
                        if (suc) {
                            this.setState({ totalSize: data_sizes.sum });
                        }
                    },
                    IDs.MOD_ETOOL);
            }
        }, 2000);
        this.buildHandle = handle;
    }

    setFilenames(map: any): void {
        Object.keys(this.dataForExport).forEach((key: string) => {
            const items = this.dataForExport[key];
            const cols = this.colsForExport[key];
            items.forEach((item: any) => {
                cols.forEach((col: any) => {
                    if (col.type && col.type === 'FILE') {
                        if (item[col.accessor] && map[item[col.accessor] + '']) {
                            item._original[col.accessor] = map[item[col.accessor] + ''];
                            item[col.accessor] = map[item[col.accessor] + ''];
                        }
                    }
                });
            });
        });
    }

    prepareFiles(): any {
        const files: any = {};
        const galleryData = this.props.galleryData;
        Object.keys(this.dataForExport).forEach((key: string) => {
            const items = this.dataForExport[key];
            const cols = this.colsForExport[key];
            items.forEach((item: any) => {
                cols.forEach((col: any) => {
                    if (col.type && col.type === 'FILE') {
                        if (item[col.accessor]) {
                            files[item[col.accessor]] = `gallery/`;
                        }
                    }
                });
            });
        });
        Object.keys(galleryData).forEach((gallery_key: string) => {
            galleryData[gallery_key].forEach((g_item: any) => {
                if (!files[g_item.foto]) {
                    files[g_item.foto] = `gallery/`;
                }
            });
        });
        return files;
    }
}
